/**
 * Glowwa: Stockist carousel — initial centre positioning.
 *
 * Sets scrollLeft to card 2 (index 1) before the first paint so there's
 * no visible jump. Works because glowwa-tabs-inactive.css forces
 * overflow-x: scroll on this carousel's slideshow-slides, bypassing
 * the HW in-viewport lazy-scroll activation.
 */

(function () {
  function initStockistCarousel() {
    const section = document.getElementById('stockists');
    if (!section) return;
    if (window.innerWidth >= 750) return;

    const slides = section.querySelector('slideshow-slides');
    if (!slides) return;

    const cards = slides.querySelectorAll('.card, [data-carousel-card]');
    if (cards.length < 2) return;

    const card = cards[1];
    const cardCenter = card.offsetLeft + card.offsetWidth / 2;
    const targetScroll = cardCenter - slides.clientWidth / 2;
    slides.scrollLeft = Math.max(0, targetScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStockistCarousel);
  } else {
    initStockistCarousel();
  }
})();
